export default __webpack_public_path__ + "static/media/how-it-works.445f5e5a.gif";